import { PayloadAction } from '@reduxjs/toolkit';
import { Bank, Card, TaxProfile, VirtualAccount } from './type';
import { PaymentState } from './state';

const reducers = {
  setVirtualAccount(
    state: PaymentState,
    action: PayloadAction<VirtualAccount>,
  ): PaymentState {
    state.virtual_account = action.payload;
    return state;
  },
  setCards(state: PaymentState, action: PayloadAction<Card[]>): PaymentState {
    state.cards = action.payload;
    return state;
  },
  selectCard(state: PaymentState, action: PayloadAction<Card>): PaymentState {
    state.select_card = action.payload;
    return state;
  },
  selectVirtualAccount(
    state: PaymentState,
    action: PayloadAction<VirtualAccount>,
  ): PaymentState {
    state.select_virtual_account = action.payload;
    return state;
  },
  setTaxProfile(
    state: PaymentState,
    action: PayloadAction<TaxProfile>,
  ): PaymentState {
    state.tax_profile = action.payload;
    return state;
  },
  setBanks(state: PaymentState, action: PayloadAction<Bank[]>): PaymentState {
    state.banks = action.payload;
    return state;
  },
};

export default reducers;
